angular.module('myApp.sitemap', ['ngRoute']).config(['$routeProvider', function($routeProvider) {
	$routeProvider.when('/sitemap', {
		templateUrl: 'components/sitemap/sitemap.html',
		controller: 'sitemapCtrl'
	})
    $routeProvider.when('/sitemap/:offering/:city', {
		templateUrl: 'components/sitemap/leveltwo.html',
		controller: 'sitemapCtrl'
        
	})
      $routeProvider.when('/sitemap/:offering/:city', {
		templateUrl: 'components/sitemap/leveltwo.html',
		controller: 'sitemapCtrl'
      })
}]).controller('sitemapCtrl', ['$scope', '$window', '$timeout', '$routeParams', 'API','CITY', function($scope,
	$window, $timeout, $routeParams, API,CITY) {
    BASE_URL="https://prod-fresh-api-v2.jugnoo.in:4009/";
    $window.scrollTo(0, 0);
    
    
    $scope.businessCity =[{"city_id":1,"city_name":"Chandigarh"},{"city_id":7,"city_name":"Gurgaon"},{"city_id":8,"city_name":"Indore"},{"city_id":17,"city_name":"Noida"},{"city_id":28,"city_name":"Faridabad"},{"city_id":15,"city_name":"Surat"},{"city_id":19,"city_name":"Jodhpur"},{"city_id":13,"city_name":"Pune"},{"city_id":31,"city_name":"Bhopal"},{"city_id":12,"city_name":"Nagpur"},{"city_id":4,"city_name":"Jaipur"},{"city_id":9,"city_name":"Delhi"},{"city_id":27,"city_name":"Bengaluru"},{"city_id":18,"city_name":"Hyderabad"},{"city_id":23,"city_name":"Udaipur"},{"city_id":2,"city_name":"Ludhiana"},{"city_id":11,"city_name":"Ahmedabad"},{"city_id":14,"city_name":"Vadodara"},{"city_id":16,"city_name":"Nasik"},{"city_id":20,"city_name":"Guwahati"},{"city_id":21,"city_name":"Mysore"},{"city_id":22,"city_name":"Bhubaneswar"},{"city_id":24,"city_name":"Kota"},{"city_id":25,"city_name":"Coimbatore"},{"city_id":30,"city_name":"Rajkot"},{"city_id":33,"city_name":"Lucknow"},{"city_id":71,"city_name":"Kharar"},{"city_id":46,"city_name":"Madurai"},{"city_id":41,"city_name":"Kanpur"},{"city_id":72,"city_name":"Zirakpur"},{"city_id":73,"city_name":"Panchkula"}]
       .sort(function(a, b) {
                var nameA = a.city_name.toUpperCase();
                var nameB = b.city_name.toUpperCase();
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                return 0;
            });
    ;

    CITY.fatafat().then(function(result) {
         $scope.cityList = result;
     })

    CITY.rides().then(function (result) {
         $scope.ridesCityList = result;
     })


  
	}])	
	
    
    
    

